import { AuthenticationModel } from './dto/authenticationModel';
import { AuthenticationResultModel } from './dto/authenticationResultModel';
import http from '../httpService';
import { ChangePasswordInput } from './dto/changePasswordInput';
import AppConsts from '@/lib/appconst';

class UnAuthentService {
  public async authenticate(authenticationInput: AuthenticationModel): Promise<AuthenticationResultModel> {
    let result = await http.post('api/TokenAuth/Authenticate', authenticationInput);
    return result.data.result;
  }
  public async authenticateByOAuth(request: {
    code?: string,
    appCode?: string
  }): Promise<AuthenticationResultModel> {
    let result = await http.post('api/TokenAuth/AuthenticateByOAuth', request);
    return result.data.result;
  }

  public async scanCodeAuthenticate(Code: string): Promise<AuthenticationResultModel> {
    let result = await http.get('api/TokenAuth/ScanCodeAuthenticate', { params: { Code: Code, secretKey: AppConsts.secretKey } });
    return result.data.result;
  }
  //修改密码
  public async changePassword(changePasswordInput: ChangePasswordInput) {
    let result = await http.post('api/services/app/User/ChangePassword', changePasswordInput);
    return result.data;
  }
}
export default new UnAuthentService();